import WikiList from "./WikiList";

import "./WikiList.scss";

export * from "./WikiList.types";

export { WikiList };
